module.exports = __webpack_public_path__ + "static/media/landing-auto-relist.eee867d3.png";